export const DialogStyle = {
  dialogContent: {
    height: '300px',
    width: '600px',
    marginTop: '0px',
    p: 1,
  },
  dialogContentText: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px',
  },
  linkedIn: {
    marginRight: '8px',
  },
};
